import {
  constants,
  mediaQueryStyles,
  typographyStyles,
  cssVariableStyles,
} from "@newsela/angelou";

const { colors, breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { md } = breakpoints.BreakpointNames;
const { textXSObj, textCapsObj } = typographyStyles;
const { generateTooltipDialogVariables } = cssVariableStyles;

const white = colors.ui.white[700];
const greyDark = colors.ui.neutral[600];

const dialogStyles = generateTooltipDialogVariables({
  backgroundColor: white,
  borderWidth: "2px",
});

export const sharedStatusContainerCss = {
  ...textCapsObj,
  fontSize: "0.75rem",
  color: greyDark,
  letterSpacing: "1px",
  display: "flex",
  alignItems: "center",
};

export const infoButtonRootCss = {
  backgroundColor: "none",
};

export const infoIconCss = {
  width: "15px",
  path: {
    strokeWidth: 3,
  },
  circle: {
    strokeWidth: 2.5,
  },
};

export const closeIconCss = {
  width: "15px",
};

export const dialogContainerCss = {
  ...dialogStyles,
  maxWidth: "240px",
  // The caret palcement is dependent on the width of the button, and since our info icon is tiny,
  // the caret was misaligned to the far right of the dialog, so we want to scoot it over to the right a bit.
  marginLeft: "35px",
  "div:last-of-type": {
    marginLeft: "-35px",
    marginTop: "-0.5px",
  },
  // Because the activity panel has a z-index on smaller sizes, we need to add one to the dialog
  // so it appears on top of the panel.
  [mediaQuery.upTo(md)]: {
    zIndex: 12,
  },
};

export const sharedStatusTextCss = {
  marginLeft: "5px",
};

export const tooltipTextCss = {
  ...textXSObj,
  letterSpacing: "0.1px",
  margin: 0,
  // Allows for new lines (\n) to appear in the text.
  whiteSpace: "pre-wrap",
};

export const shareStatusHeaderCss = {
  ...textXSObj,
  textTransform: "uppercase",
  letterSpacing: "1px",
};
